module.exports = __webpack_public_path__ + "static/02-e5652c7a514d2ec96d2837980ea242e3.png";